/**
 * Polyfill for BigInt JSON serialization
 *
 * This enables us to call JSON.stringify on BigInt values without error
 *
 * See https://stackoverflow.com/questions/65152373/typescript-serialize-bigint-in-json
 * for more information
 */

// eslint-disable-next-line unused-imports/no-unused-vars
interface BigInt {
  /** Convert BigInt to string form in JSON.stringify */
  toJSON: () => string;
}

BigInt.prototype.toJSON = function () {
  return this.toString();
};
